<template>
    <div>
        <div class="d-flex justify-content-between align-items-start mb-3">
            <div>
                <h4>{{ $t('batches') }}</h4>
                <small class="text-muted" v-if="batches.length > 0">
                    {{ batches.length }} {{ $t('batchesInDataSpace') }}
                </small>
            </div>
            <button class="btn btn-primary btn-sm" @click="createBatch">
                <i class="fas fa-plus"></i> {{ $t('newBatch') }}
            </button>
        </div>

        <table class="table table-hover" v-if="batches.length > 0">
            <thead>
                <tr>
                    <th>{{ $t('name') }}</th>
                    <th>{{ $t('type') }}</th>
                    <!-- <th>{{ $t('status') }}</th>
                    <th>{{ $t('lastRun') }}</th>
                    <th>{{ $t('duration') }}</th> -->
                    <th class="text-end"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in batches" :key="item.id">
                    <td>
                        <strong>{{ item.name }}</strong>
                    </td>
                    <td>
                        <span class="badge-type">{{ item.batchType || '–' }}</span>
                    </td>
                    <!-- <td>
                        <span :class="statusBadgeClass(item.status)">{{ statusLabel(item.status) }}</span>
                    </td>
                    <td class="text-muted">{{ formatDate(item.lastRunDate) }}</td>
                    <td class="text-muted">{{ formatDuration(item.durationSeconds) }}</td> -->
                    <td class="text-end">
                        <button class="btn btn-sm btn-icon" @click="editBatch(item)" :title="$t('edit')">
                            <i class="fas fa-pencil-alt"></i>
                        </button>
                        <button class="btn btn-sm btn-icon" @click="runBatch(item)"  :title="$t('run')" :disabled="item.status === 'Running'">
                            <i class="fas fa-play"></i>
                        </button>
                        <button class="btn btn-sm btn-icon" @click="copyBatch(item)" :title="$t('copy')">
                            <i class="fas fa-copy"></i>
                        </button>
                        <button class="btn btn-sm btn-icon" @click="deleteBatch(item)" :title="$t('delete')">
                            <i class="fas fa-trash-alt"></i>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
        <div v-else class="text-muted">{{ $t('noBatches') }}</div>
        <DataBatchAdd v-if="showForm" @created="showForm = false; loadBatches()" @cancel="showForm = false" />
        <DataBatchRunModal v-if="showDataBatchRun && runningBatch" :batch="runningBatch" @reload="loadBatches()" @close="closeBatchRun" />
        <DataBatchCopyModal v-if="showCopy && copyingBatch" :batch="copyingBatch" @reload="loadBatches()" @close="closeCopy" />
        <DataBatchDeleteModal v-if="showDelete && deletingBatch" :batch="deletingBatch" @reload="loadBatches()" @close="closeDelete" />
    </div>
</template>

<script>
import DataBatchApi from '../../api/server/databatch';
import DataBatchAdd from './DataBatchAdd.vue';
import DataBatchRunModal from './DataBatchRunModal.vue';
import DataBatchCopyModal from './DataBatchCopyModal.vue';
import DataBatchDeleteModal from './DataBatchDeleteModal.vue';

export default {
    name: 'DataBatchList',
    components: { DataBatchAdd, DataBatchRunModal, DataBatchCopyModal, DataBatchDeleteModal },
    data() {
        return {
            batches: [],
            filterInput: '',
            showForm: false,
            showDataBatchRun: false,
            runningBatch: null,
            showCopy: false,
            copyingBatch: null,
            showDelete: false,
            deletingBatch: null,
        };
    },
    computed: {
        dataSpaceId() {
            return this.$route.params.id;
        }
    },
    mounted() {
        this.loadBatches();
    },
    methods: {
        editBatch(item) {
            this.$router.push(`/dataspace/${this.dataSpaceId}/batches/${item.id}`);
        },
        createBatch() {
            this.showForm = true;
        },
        async loadBatches() {
            var list = await DataBatchApi.dataBatchList(this.dataSpaceId);
            this.batches = list.sort((a, b) => a.name.localeCompare(b.name)).map(b => { 
                return b; 

            });
        },
        async runBatch(item) {
            this.runningBatch = item;
            this.showDataBatchRun = true;
        },
        closeBatchRun() {
            this.showDataBatchRun = false;
            this.runningBatch = null;
        },
        statusBadgeClass(status) {
            var classes = {
                'Draft': 'badge-status badge-draft',
                'Ready': 'badge-status badge-ready',
                'Running': 'badge-status badge-running',
                'Completed': 'badge-status badge-completed',
                'Error': 'badge-status badge-error'
            };
            return classes[status] || 'badge-status badge-draft';
        },
        statusLabel(status) {
            var labels = {
                'Draft': this.$t('statusDraft'),
                'Ready': this.$t('statusReady'),
                'Running': this.$t('statusRunning'),
                'Completed': this.$t('statusCompleted'),
                'Error': this.$t('statusError')
            };
            return labels[status] || status;
        },
        formatDate(date) {
            if (!date) return '–';
            return new Date(date).toLocaleString();
        },
        formatDuration(seconds) {
            if (seconds == null) return '-';
            var min = Math.floor(seconds / 60);
            var sec = seconds % 60;
            return `${min} min ${String(sec).padStart(2, '0')} s`;
        },
        copyBatch(item) {
            this.copyingBatch = item;
            this.showCopy = true;
        },
        closeCopy() {
            this.showCopy = false;
            this.copyingBatch = null;
        },
        deleteBatch(item) {
            this.deletingBatch = item;
            this.showDelete = true;
        },
        closeDelete() {
            this.showDelete = false;
            this.deletingBatch = null;
        },
    },
    notifications: {
        showRunSuccess: { 
            title: 'success',
            message: 'batchRunSuccessful',
            type: 'success'
        },
        showRunFail: { 
            title: 'failed',
            message: 'batchRunUnsuccessful',
            type: 'error'
        }
    }
};
</script>